import { atom } from "jotai";

export const isInvoiceActionsMutationsLoadingAtom = atom<boolean>(false);
